export const SvgCopy = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2030%2030"%3E%3Cpath%20d%3D"M0%200v24.25h2.67V2.37h21V0Z"%2F%3E%3Cpath%20d%3D"M6.52%2030H30V6.22H6.52Zm20.81-2.37H9.19v-19h18.14Z"%2F%3E%3C%2Fsvg%3E';
export default SvgCopy;
